// 构建 clientVars 默认参数
export const MAX_MANUAL_COUNT = 100;
export const DVER = '3.0.0';
export const INIT_MAX = 2147483647;
export const SUB_ID = 'BB08J2';

export enum OfflineEditReport {
    LAUNCHING = 9990,
    LAUNCHED = 9991,
    USE_OFFLINE = 9992,
    USE_ONLINE = 9993,
    USE_OFFLINE_CREATE = 9994,
    REMOVE_CS = 9995,
    APPLY_OFFLINE_DATA_START = 9996,
    APPLY_OFFLINE_DATA_END = 9997,
    FETCH_FAIL = 9998,
}

/**
 * 客户端ListType
 *
 * @export
 * @enum {number}
 */
export enum AppDocsListType {
    listTypeOffline = -1, // 离线列表
    listTypeAll = 1, // 全部文档列表
    listTypeCreated = 2, // 我创建的列表
    listTypeTrash = 3, // 回收站列表
    listTypeShared = 4, // 与我共享的列表
    listTypeMyDoc = 5, // 我的文档列表
    listTypeRecent = 6, // 我最近浏览列表
    listTypeStared = 7, // 星标列表
    listTypeInSharedFolder = 9, // 共享文件夹内，发送cgi时如果当前文档在共享文件夹内，list_type传入listTypeInSharedFolder
}
